import { HistoryListProps } from "@husky-x/history-list";

export const HistoryMock: HistoryListProps  = {
	data: [
		{
			year: 1915,
			description: 'LA Jackson startar London Rubber Company och börjar sälja importerade kondomer och tillbehör.',
		},
		{
			year: 1929,
			description: 'London Rubber Company (LRC) registrerar varumärket Durex.',
		},
		{
			year: '1950-talet',
			description: 'Durex lanserar sin första kondom med glidmedel.',
		},
		{
			year: 1953,
			description: 'Durex blir den första kondomtillverkaren som utvecklar och använder elektronisk testning.',
		},
		{
			year: '1960-talet',
			description: 'Durex lanserar sin första anatomiskt formade kondom.',
		},
		{
			year: '1970-talet',
			description: 'Durex är den första kondomtillverkaren som gör reklam i många länder.',
		},
		{
			year: '1990-talet',
			description: 'Durex är den första kondomtillverkaren som antar en global ”kvalitetssäkring” som standard.',
		},
		{
			year: 1995,
			description: 'Durex introducerar ett utbud av färgglada och smaksatta kondomer.',
		},
		{
			year: 1996,
			description: 'Durex är den första kondomtillverkaren som skapar en webbplats. I dag finns det 42 olika webbplatser för de länder där vi är representerade.',
		},
		{
			year: 1997,
			description: 'Durex lanserar latexfria kondomer. Ett nytt icke-allergent material används för den nya produkten: syntetiskt polyuretan som har utvecklats av Durex och är mjukare och mer elastiskt än naturligt latexgummi.',
		},
		{
			year: 1998,
			description: 'Durex är det första kondomföretaget som genomför och publicerar en enkätundersökning om sexuellt välbefinnande.',
		},
		{
			year: 2001,
			description: 'Durex lanserar Pleasuremax. Durex blir därmed den första kondomtillverkaren som marknadsför en kondom med både ribbad och knottrig struktur som stimulerar båda parter.',
		},
		{
			year: 2003,
			description: 'Durex lanserar ett spännande utbud av glidmedel i Play®-serien.',
		},
		{
			year: 2005,
			description: 'Durex Network presenterar Face of Global Sex-rapporterna där vi utforskar aspekter av människans sexuella beteenden. Det främsta syftet är att skapa informationsunderlag för forskare och beslutsfattare.',
		},
		{
			year: 2008,
			description: 'För att öka medvetenheten om säkert sex hos unga tog Durex initiativet att låta ungdomar mellan 16 och 24 år utforma en unik affisch om sexuell hälsa för tonåringar.',
		},
		{
			year: 2009,
			description: 'Durex fyller 80 år!',
		},
		{
			year: 2010,
			description: 'Durex stödjer initiativet Condomize! från FN:s befolkningsfond (UNFPA) vid den internationella AIDS-konferensen i Wien genom att donera 220 000 kondomer.',
		},
		{
			year: 2010,
			description: 'Durex köps av Reckitt Benckiser.',
		},
		{
			year: 2010,
			description: 'Durex lanserar Performax Intense, en kondom designad för samtidig orgasm. Belagd med 5 % bensokain på insidan och med en stimulerande struktur som bidrar till längre och mer intensivt sex.',
		},
		{
			year: 2019,
			description: 'Durex fuller 90 år!',
		},
	]
}